import type { RouteRecordRaw } from "vue-router";
import { redirectToAuth } from "@/helpers/authRedirect.js";

const publicRoutes = [
  {
    path: "/:authType(login|register|invite)",
    name: "AuthRedirect",
    children: [],
    beforeEnter: (to) => {
      redirectToAuth(to.params.authType, to.query);
      return false;
    },
  },
  {
    path: "/signup-completion",
    name: "SignupCompletion",
    component: () => import("@/pages/SignupCompletion/SignupCompletion.vue"),
  },
  {
    path: "/azkaban",
    name: "Azkaban",
    component: () => import("@/pages/SignupCompletion/Azkaban.vue"),
  },
  {
    path: "/watch",
    name: "Watch",
    component: () => import("@/pages/IpBlockedView.vue"),
  },
  {
    path: "/supplier-questionnaire",
    name: "SupplierQuestionnaire",
    component: () => import("@/pages/SupplierQuestionnaireView.vue"),
  },
  {
    path: "/p",
    redirect: "/login",
  },
  {
    path: "/p/:id",
    name: "PublicPpwr",
    component: () => import("@/pages/Public/PublicPpwrView.vue"),
    props: true,
  },
  // Maintenance page
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("@/pages/MaintenanceView.vue"),
  },
  {
    path: "/session-expired",
    name: "SessionExpired",
    component: () => import("@/pages/SessionExpiredView.vue"),
  },
] as const satisfies RouteRecordRaw[];

export default publicRoutes.map((route) => ({
  ...route,
  meta: { private: false },
}));
